import { IEditRow } from "./TableEditableConfig";

interface IButtonNewRowProps {
  table: any
  editRow?: IEditRow
}

export const ButtonNewRow = (params: IButtonNewRowProps) => {
  const meta = params.table.options.meta

  return (
    <div className='footer-buttons'>
      <button type='button' className='add-button' onClick={meta?.addRow} disabled={params.editRow?.isEdit}>
        Add New <i className='bi bi-plus-lg'></i>
      </button>
    </div>
  )
}